var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('excelUploadCard',{attrs:{"urlItem":"","title":_vm.$t('Upload household list'),"loadbtn":_vm.$t('Select household list')}}),_c('excelUploadCard',{attrs:{"urlItem":"","title":_vm.$t('Upload policies'),"loadbtn":_vm.$t('Select policies')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }